import { StoreModule } from '@ngrx/store';
import { SharedModule } from '@shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OptimizelyEffects } from './store/effects/index';
import { OPTLY_FEATURE, optlyReducers } from './store/reducers/index';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(OPTLY_FEATURE, optlyReducers),
    EffectsModule.forFeature(OptimizelyEffects),
  ],
})
export class OptlyModule {}
